import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';
import socketService from '../services/socketService';
import apiService from '../services/api';

const TestContainer = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
`;

const TestCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Button = styled.button`
  background: #F68B21;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 0.5rem;
  
  &:hover {
    background: #e67c1a;
  }
`;

const StatusIndicator = styled.div<{ connected: boolean }>`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props => props.connected ? '#28a745' : '#dc3545'};
  margin-right: 0.5rem;
`;

const TestNotifications: React.FC = () => {
  const { user } = useAuth();
  const [socketConnected, setSocketConnected] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [lastNotification, setLastNotification] = useState<any>(null);

  useEffect(() => {
    // Check socket connection status
    const checkConnection = () => {
      setSocketConnected(socketService.isSocketConnected());
    };

    checkConnection();
    const interval = setInterval(checkConnection, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Listen for real-time notifications
    socketService.onNotification((data) => {
      console.log('Test: New notification received:', data);
      setLastNotification(data.notification);
      setNotificationCount(data.unreadCount || 0);
    });

    return () => {
      socketService.offNotification();
    };
  }, []);

  const testCreateNotification = async () => {
    try {
      const response = await apiService.createNotification({
        type: 'Test',
        title: 'Test Notification',
        message: 'This is a test notification sent at ' + new Date().toLocaleTimeString(),
        data: {
          test: true,
          timestamp: new Date().toISOString()
        }
      });
      console.log('Test notification created:', response);
    } catch (error) {
      console.error('Error creating test notification:', error);
    }
  };

  const getNotifications = async () => {
    try {
      const response = await apiService.getNotifications();
      console.log('Current notifications:', response);
      setNotificationCount(response.unreadCount || 0);
    } catch (error) {
      console.error('Error getting notifications:', error);
    }
  };

  return (
    <TestContainer>
      <h1>Real-time Notification Test</h1>
      
      <TestCard>
        <h3>Connection Status</h3>
        <p>
          <StatusIndicator connected={socketConnected} />
          Socket.IO: {socketConnected ? 'Connected' : 'Disconnected'}
        </p>
        <p>User ID: {user?.id}</p>
        <p>Unread Notifications: {notificationCount}</p>
      </TestCard>

      <TestCard>
        <h3>Test Actions</h3>
        <Button onClick={testCreateNotification}>
          Create Test Notification
        </Button>
        <Button onClick={getNotifications}>
          Get Notifications
        </Button>
      </TestCard>

      {lastNotification && (
        <TestCard>
          <h3>Last Received Notification</h3>
          <p><strong>Title:</strong> {lastNotification.title}</p>
          <p><strong>Message:</strong> {lastNotification.message}</p>
          <p><strong>Type:</strong> {lastNotification.type}</p>
          <p><strong>Received at:</strong> {new Date(lastNotification.createdAt).toLocaleString()}</p>
        </TestCard>
      )}
    </TestContainer>
  );
};

export default TestNotifications; 